import { useTranslation } from 'react-i18next';
import { isNullish } from '@/utils/predicates';

export const useSliderLabel = (minValue: number | undefined, maxValue: number | undefined, isReversed?: boolean) => {
  const { t } = useTranslation('filters');

  const minUnset = isNullish(minValue);
  const maxUnset = isNullish(maxValue);
  if (minUnset && maxUnset) return t('anyValue');

  if (minValue === maxValue) return `${minValue}`;
  if (minUnset) return `≤ ${maxValue}`;
  if (maxUnset) return `≥ ${minValue}`;

  return isReversed ? `${maxValue} - ${minValue}` : `${minValue} - ${maxValue}`;
};
